import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { Link } from 'react-router-dom';
import { formatMoney } from 'accounting';

import { getItemType } from '../../../config/constants';
import Transaction from '../../../models/Transaction';
import Contact from '../../../models/Contact';
import rightArrowIcon from '../../../images/right-arrow.svg';

class SalesTable extends React.PureComponent {
  render() {
    const { transactions, contacts, header } = this.props;

    /* eslint-disable react/prop-types */
    const columns = [
      {
        Header: 'Type',
        accessor: 'category',
        Cell: ({ value }) => <Link to={`/collections/${value}`}>{getItemType(value)}</Link>,
      },
      {
        Header: 'Name',
        accessor: 'itemTitle',
        Cell: ({ original: { category, itemId }, value }) => {
          // TODO: Faking the secondary URL attributes. Should be getting permalink.
          return <Link to={`/collections/${category}/_/_/${itemId}`}>{value}</Link>;
        },
      },
      {
        Header: 'Seller',
        accessor: 'contactId',
        Cell: ({ value }) => {
          if (value === 0) return <span />;
          return (
            <Link to={`/contacts/${value}`}>{contacts[value] ? contacts[value].name : null}</Link>
          );
        },
      },
      {
        Header: 'Date',
        accessor: 'transactionDate',
        Cell: props => <span>{props.value.toLocaleDateString()}</span>,
      },
      {
        Header: 'Amount',
        accessor: 'transactionValue',
        Cell: props => <span>{formatMoney(props.value)}</span>,
      },
      {
        Header: 'Gain / Loss',
        accessor: 'gain',
        show: this.props.showGainLoss,
        Cell: props => (
          <span style={{ color: props.value >= 0 ? 'rgb(12, 202, 12)' : 'rgb(204, 11, 11)' }}>
            {formatMoney(props.value)}
          </span>
        ),
      },
      {
        Header: '',
        accessor: 'itemId',
        width: 24,
        Cell: props => (
          <Link to={`/transactions/${props.value}`}>
            <img
              src={rightArrowIcon}
              alt="View Transaction"
              style={{
                width: 16,
                height: 16,
              }}
            />
          </Link>
        ),
      },
    ];
    /* eslint-enable react/prop-types */

    return (
      <div>
        {header && <h4 className="subtitle is-4">{header}</h4>}
        <ReactTable
          data={transactions}
          columns={columns}
          defaultSorted={[
            {
              id: 'transactionDate',
            },
          ]}
          defaultSortDesc
          showPageSizeOptions={false}
          showPageJump={false}
          defaultPageSize={10}
          minRows={1}
          className="-highlight"
        />
      </div>
    );
  }
}

SalesTable.propTypes = {
  transactions: PropTypes.arrayOf(PropTypes.instanceOf(Transaction)),
  contacts: PropTypes.objectOf(PropTypes.instanceOf(Contact)),
  showGainLoss: PropTypes.bool,
  header: PropTypes.string,
};

SalesTable.defaultProps = {
  transactions: [],
  contacts: {},
  showGainLoss: false,
  header: '',
};
export default SalesTable;



// WEBPACK FOOTER //
// ./src/components/pages/financials/SalesTable.jsx